import React, { useState } from "react";
import {Link} from 'react-router-dom'


const images = [
  {
    id: 1,
    name: "cleaning",
    agriculture: true,
    title:"Window Cleaning",
    subTitle:"System",
    imgUrl: require("../../images/portfolio/PROJECT 1 - Window Cleaning.png")
  },
  {
    id: 2,
    name: "agriculture",
    agriculture: true,
    title:"Mining Plant Set Up",
    subTitle:"Mining / Plants",
    imgUrl: require("../../images/portfolio/PROJECT 2.png")
  },
  {
    id: 3,
    name: "cleaning",
    agriculture: true,
    title:"Carpet Cleaning",
    subTitle:"Engineering",
    imgUrl: require("../../images/portfolio/PROJECT 3 - Carpet Cleaning.png")
  },
  

];


const getFilterSections = (images)=>{
  const filters = ['all']
  images.map(()=>(image)=>{
    if(filters.indexOf(image.name) === -1){
      filters.push(image.name)
    }
  })
  return filters
}

const filterImages = (filterKey,images)=>{
  const list = images.filter(image =>
    filterKey === 'all' ? image : image.name === filterKey
  );

  return list
}

const Portfolio = props => {
  const [state, setState] = useState({
    list: images,
    filterKey: "all"
  });

  const { list, filterKey } = state;
  
  const filteredList  = filterImages(filterKey,list)
  const filters       = getFilterSections(images)
  const collumnCls = props.col ? props.col :"col-md-3";

  return (
   
      <div className="section-full content-inner-2 pt-0 portfolio text-uppercase bg-gray" id="portfolio">
        <div className="container"> 
          <div className="site-filters clearfix center  ">
            {/* FILTERS */}
            {/* <ul className="filters" data-toggle="buttons">
              {filters.map(filter =>(
                <li className="btn" onClick={() => setState({ ...state, filterKey: filter })}>
                  <div className="site-button-secondry button-sm radius-xl">
                    <span>{filter}</span>
                  </div>
                </li >
              ))}
            </ul> */}
          </div> 
           
            {/* FILTERED PORTFOLIO LIST */}
            <div className="portfolio_area">
              <div className="row portfolio-grid">
                  {filteredList.map(image => (
                    <div className={collumnCls}>
                      <div className="dlab-box dlab-gallery-box">
                        <div className="dlab-media dlab-img-overlay1 dlab-img-effect">
                            <Link to="#"> <img src={image.imgUrl}  alt=""/> </Link>
                            <div className="overlay-bx">
                                {/* <div className="overlay-icon"> 
                                    <div className="text-white">
                                        <Link to="#"><i className="fa fa-link icon-bx-xs"></i></Link> 
                                        <span className="check-km" title="Factory Managment">		
                                            <i className="fa fa-picture-o icon-bx-xs"></i> 
                                        </span>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="dez-info p-a30 bg-white">
                            <p className="dez-title m-t0"><Link to="#">{image.title}</Link></p>
                            <p><small>{image.subTitle}</small></p>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
          </div>
        </div>
      </div>
          


  );
};

export default Portfolio;
